import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { ConfigService } from '../../helpers/config.service';

@Injectable({
  providedIn: 'root'
})
export class LoyaltySsoService {
  private readonly codeMap = {
    'amadeus-plus-me-gift-catalog': {
      path: 'pointsReportLink',
      query: '&goto=gifts'
    },
    'edenred-support-page': {
      path: 'supportLink',
      query: '&goto=ContactUs'
    }
  };

  constructor(private readonly httpClient: HttpClient,
    private readonly initService: ConfigService,
    @Inject('API') private readonly api) {}

  getAllCodes(): string[] {
    return Object.keys(this.codeMap);
  }

  // @loyaltyDocs: get customer-specific URL from Java BE and then open desired pagee
  openLink(code: string) {
    if (!this.codeMap[code]) {
      return;
    }
    this.httpClient
      .get(this.initService.getEnvConfig().AD_JAVA_API_URL + this.api.sso.ssoLoyalty() + this.codeMap[code].path, {
        responseType: 'text'
      })
      .pipe(take(1))
      .subscribe((res: any) => {
        let url = res.toString();
        if (this.codeMap[code].path !== 'supportLink') {
          url = res.toString() + this.codeMap[code].query;
        }
        window.open(url);
      });
  }
}
